import { render, staticRenderFns } from "./VAnswer.vue?vue&type=template&id=5418b1a6"
import script from "./VAnswer.vue?vue&type=script&lang=js"
export * from "./VAnswer.vue?vue&type=script&lang=js"
import style0 from "./VAnswer.vue?vue&type=style&index=0&id=5418b1a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../home/michael/.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports